import { LogsApiDataItemCustom } from '../../TypeScript/interfaces';
import { JsonDataframe } from '../../TypeScript/types';

/**
 * columns to exclude from the dataset because they are metadata from the (mongodb) logs api
 */
export const DATABASE_COLUMNS = [
  '_id',
  'created_at',
  'created_by',
  'updated_at',
  'updated_by',
  'log_id',
];

/**
 * Converts data from the logs api into a json dataframe to be used in the app
 * @param items list of data items from logs api
 * @returns the data in json dataframe format
 */
export const logsToDataframe = (
  items: LogsApiDataItemCustom[],
): JsonDataframe => {
  const dataframe: JsonDataframe = {};
  const keys = Object.keys(items[0]).filter(
    (key: string) => !DATABASE_COLUMNS.includes(key),
  );
  keys.forEach((key: string) => {
    dataframe[key] = {};
  });
  items.forEach((item: LogsApiDataItemCustom, index: number) => {
    keys.forEach((key: string) => {
      dataframe[key][`${index}`] = item[key];
    });
  });
  return dataframe;
};
